import Model from 'flarum/common/Model';

export default class CaseFeedback extends Model {}

Object.assign(CaseFeedback.prototype, {
  caseId: Model.attribute('case_id'),
  userId: Model.attribute('user_id'),
  rating: Model.attribute('rating'),
  isVisible: Model.attribute('is_visible'),
  content: Model.attribute('content'),
  createdAt: Model.attribute('created_at', Model.transformDate),
  updatedAt: Model.attribute('updated_at', Model.transformDate),

  case: Model.hasOne('case'),
  user: Model.hasOne('user'),
});
